import React from "react";
import styled, { keyframes } from "styled-components";
import {
  UnPinIcon,
  ReportIcon,
  DeleteIcon,
  CloseIcon,
} from "../../../../components/svgs";
import PinnedIconNoOutline from "../../../../components/svgs/pinnedIconNoOutline";

const CommentModal = ({
  show,
  onClose,
  onPinClick,
  onReportClick,
  onDeleteClick,
  commentId,
  isPinned = "Pin comment",
  isMyComment = false,
  isReported = false,
}) => {
  if (!show) return null;

  const handlePinClick = () => {
    if (onPinClick) {
      onPinClick(commentId);
    }
    onClose();
  };

  const handleReportClick = () => {
    if (onReportClick) {
      onReportClick(commentId);
    }
    onClose();
  };

  const handleDeleteClick = () => {
    if (onDeleteClick) {
      onDeleteClick(commentId);
    }
    onClose();
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalBorder>
          <ModalTitle>Select action</ModalTitle>
          <HorizontalLine />
          <ActionList>
            {/* Pin Action */}
            <PinActionItem onClick={handlePinClick}>
              <div style={{ width: "30px" }}>
                {isPinned ? <UnPinIcon /> : <PinnedIconNoOutline />}
              </div>
              <ActionText>
                {isPinned ? "Unpin comment" : "Pin comment"}
              </ActionText>
            </PinActionItem>

            {/* Conditional actions based on `isMyComment` */}
            {isMyComment ? (
              <>
                {/* Delete Action for Own Comment */}
                <DeleteActionItem onClick={handleDeleteClick}>
                  <div style={{ width: "30px" }}>
                    <DeleteIcon />
                  </div>
                  <ActionText>Delete comment</ActionText>
                </DeleteActionItem>
              </>
            ) : (
              <>
                {/* Report Action for Other Users' Comments */}
                <ReportActionItem onClick={handleReportClick}>
                  <div style={{ width: "30px" }}>
                    <ReportIcon fill={isReported ? "red" : "#000"} />
                  </div>
                  <ReportText isReported={isReported}>
                    {isReported ? "Comment Reported" : "Report comment"}
                  </ReportText>
                </ReportActionItem>
              </>
            )}
          </ActionList>
        </ModalBorder>
        <CancelButton onClick={onClose}>
          <CloseIconBorder>
            <CloseIcon />
          </CloseIconBorder>
          Cancel
        </CancelButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default CommentModal;

// Styled Components
const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 10px 10px 0 0;
  width: 100%;
  max-width: 480px;
  position: relative;
  text-align: center;
  animation: ${slideUp} 0.3s ease-out;
`;

const ModalBorder = styled.div`
  padding: 20px;
`;

const ModalTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 15px;
  text-align: left;
  font-family: "MTNBold"
`;

const HorizontalLine = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #cccccc;
  margin: 10px 0;
`;

const ActionList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: MTNRegular;
`;

const ActionItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
  svg {
    margin-right: 10px;
  }
`;

const PinActionItem = styled(ActionItem)`
  padding: 15px 0;
`;

const ReportActionItem = styled(ActionItem)`
  padding: 15px 0;
`;

const DeleteActionItem = styled(ActionItem)`
  padding: 15px 0;
  color: #dc0000;
`;

const ReportText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ isReported }) => (isReported ? "red" : "#000")};
`;

const ActionText = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

const CloseIconBorder = styled.div`
  margin: 0 12px;
`;

const CancelButton = styled.button`
  display: flex;
  padding: 15px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  background: #dddddd;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
  width: 100%;
  font-family: MTNRegular;
  &:hover {
    background: #bbb;
  }
`;
